import * as React from 'react';
import { useSelector } from 'react-redux';

import { chatListSelector } from '../selectors';
import { TOffer } from '../types/offer';

export const useOfferByChatId = (): ((chatId: string) => TOffer | undefined) => {
  const { chats } = useSelector(chatListSelector);

  return React.useCallback(
    (chatId: string) => {
      const chat = chats.find(chat => chat.chatId === chatId);
      const { data } = chat || {};

      return data ? data.offer : undefined;
    },
    [chats],
  );
};
